var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6219 6.56639C17.8928 6.56533 17.194 6.27516 16.6786 5.75952C16.1632 5.24389 15.8734 4.54488 15.8727 3.81584V0H3.58784C2.63628 0 1.72372 0.377999 1.05087 1.05085C0.378015 1.7237 0 2.6363 0 3.58785V25.2163C0 26.1678 0.378015 27.0804 1.05087 27.7533C1.72372 28.4261 2.63628 28.8041 3.58784 28.8041H18.3339C18.8052 28.8043 19.2719 28.7116 19.7073 28.5314C20.1428 28.3512 20.5384 28.0869 20.8717 27.7537C21.205 27.4206 21.4694 27.025 21.6498 26.5896C21.8302 26.1542 21.9231 25.6875 21.9231 25.2163V6.56639H18.6219Z",
    fill: "#FCF4EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9225 6.56639H18.6213C17.8922 6.56533 17.1934 6.27516 16.678 5.75952C16.1626 5.24389 15.8728 4.54488 15.8721 3.81584V0L21.9225 6.56639Z",
    fill: "#DA8119"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5235 22.747H7.85216C6.66958 22.747 5.71094 23.7057 5.71094 24.8883V29.8587C5.71094 31.0413 6.66958 32 7.85216 32H24.5235C25.706 32 26.6647 31.0413 26.6647 29.8587V24.8883C26.6647 23.7057 25.706 22.747 24.5235 22.747Z",
    fill: "#DA8119"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 28.4495V29.4188H12.834V28.4495H13.8379Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8269 28.6868H15.323L15.0737 29.4188H14.0537L15.5203 25.4376H16.6376L18.1042 29.4188H17.0723L16.8269 28.6868ZM16.5763 27.9495L16.0776 26.4749L15.5737 27.9495H16.5763Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4517 25.4096V29.4188H18.4824V25.4096H19.4517Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1411 15.21C10.134 15.152 10.1403 15.0931 10.1595 15.0379C10.1787 14.9826 10.2102 14.9325 10.2518 14.8914C10.2882 14.8549 10.3314 14.826 10.379 14.8063C10.4266 14.7866 10.4776 14.7764 10.5291 14.7764C10.5806 14.7764 10.6316 14.7866 10.6792 14.8063C10.7268 14.826 10.77 14.8549 10.8065 14.8914C10.8429 14.9278 10.8718 14.971 10.8915 15.0186C10.9112 15.0662 10.9214 15.1172 10.9214 15.1687C10.9214 15.2202 10.9112 15.2712 10.8915 15.3188C10.8718 15.3664 10.8429 15.4096 10.8065 15.446C10.7653 15.4876 10.7152 15.5192 10.66 15.5384C10.6047 15.5576 10.5458 15.5638 10.4878 15.5567L5.93332 20.1112L12.733 16.778C12.733 16.778 13.497 13.9328 14.3636 13.0648L12.6304 11.3315C11.7624 12.1982 8.91718 12.9621 8.91718 12.9621L5.58398 19.7619L10.1411 15.21Z",
    fill: "#DA8119"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3352 12.0536L13.6455 9.36392L12.3266 10.6829L15.0163 13.3726L16.3352 12.0536Z",
    fill: "#DA8119"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.1af076b923a61b9b11678257e8bdcba3.svg";
export { ForwardRef as ReactComponent };